import { Button } from '@mui/material';
import styled from 'styled-components';

export const CustomSaveButton = styled(Button)``;
